import React, { Component } from "react";

import Button, { BUTTON_DISPLAY, BUTTON_SIZE } from "@acadia-ui/button";
import Tooltip, { TOOLTIP_POSITION } from "@acadia-ui/tooltip";
import Modal from "@acadia-ui/modal";
import { TOOLBAR_MODE, EDIT_BUTTON_LOCATION } from "@acadia-ui/toolbar";
import { showToast, TOAST_TYPE, ToastNotification } from "@acadia-ui/toast";

// import "./ViewCreatives.scss";
import CreativesDataStore from "../../../../Flux/Stores/CreativesDataStore";
import BookFiltersStore from "../../../../Flux/Stores/BookFiltersStore";
import { fetchCreatives } from "../../../../Flux/Actions/CreativesActions";
import NewCreative from "../../../Modals/NewCreative";
import MasterCampaignsStore from "../../../../Flux/Stores/MasterCampaignsStore";
import EditCreative from "../../../Modals/EditCreative";
import DeleteCreative from "../../../Modals/DeletePlatformModal";
import DuplicatePlatformModal from "../../../Modals/DuplicatePlatformModal";
import Table from "../../../../Components/Table/Table";
import FindReplaceModal from "../../../Modals/FindReplaceModal";
import MultiplierModal from "../../../Modals/MultiplierModal";
import { retryAtInterval } from "../retryAtInterval";
import applyFindReplaceToTable from "../applyFindReplaceToTable";
import FullFiltersSidesheet, { fullFilterAlgorithm } from "../FullFiltersSidesheet";
import WorkbookStore from "../../../../Flux/Stores/WorkbookStore";
import { COLUMNS } from "../../../../Components/ShowHideColumns";
import { draftHLISelected } from "../../../../Helpers/ActionHelpers";

class LegacyCreativesView extends Component {
	constructor() {
		super();
		this.state = {
			creativesToDelete: [],
			selectedRows: [],
			readOnly: true
		};
		this.dataTableApi = React.createRef();
		this.filterChoices = BookFiltersStore.getChoicesState();
		this.parentCampaignUniqueID = MasterCampaignsStore.getParentCampaignUniqueID();
	}

	UNSAFE_componentWillMount = () => {
		this.getCreatives();
	};

	refetchData = () => {
		const auditLevelArray = [];
		this.props.auditLevelData.forEach((auditLevel) => {
			auditLevelArray.push({ value: auditLevel.AuditLevelID, label: auditLevel.AuditLevelName });
		});
		const choices = JSON.parse(JSON.stringify(this.filterChoices));
		let auditLevelChoice = null;
		auditLevelArray.forEach((auditLevel) => {
			if (auditLevel.label === "Creative") {
				auditLevelChoice = auditLevel;
			}
		});
		if (auditLevelChoice !== null) {
			choices.auditlevel = auditLevelChoice;
			fetchCreatives(choices, this.parentCampaignUniqueID).then(() => {
				this.setState({ readOnly: true, searchValue: "", advancedFilter: false, displayFilter: false });
				this.gridChanged();
				this.props.updateCounts("Creative");
			});
		}
	};

	getCreatives = () => {
		const creativeData = CreativesDataStore.getData();
		let siteOptions = null;
		if (CreativesDataStore.getConfig().CreativeData !== undefined) {
			CreativesDataStore.getConfig().CreativeData.forEach((option) => {
				if (option.Name === "PlatformSiteID") {
					siteOptions = option.Options;
				}
			});
		}
		if (siteOptions !== null) {
			creativeData.forEach((creative) => {
				if (creative.PlatformSiteID !== null) {
					let platformName = null;
					siteOptions.forEach((site) => {
						if (creative.PlatformSiteID === site.OptionID) {
							platformName = site.OptionLabel;
						}
					});
					if (platformName !== null) {
						creative.PlatformSiteID = platformName;
					}
				}
			});
		}
		this.setState({
			creativesConfig: CreativesDataStore.getConfig(),
			creativesData: CreativesDataStore.getData(),
			loading: false
		});
	};

	componentDidMount = () => {
		CreativesDataStore.on("creatives_success", this.gridChanged);
		CreativesDataStore.on("creatives_edit_success", this.gridChanged);
		CreativesDataStore.on("create_and_add_creatives_success", this.gridChanged);
		CreativesDataStore.on("creative_deleted", this.creativeDeleted);
	};

	creativeDeleted = () => {
		this.props.updateCounts().then(() => {
			this.gridChanged();
		});
		showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.SUCCESS} message="Creative deleted successfully." timed={5000} />);
	};

	gridChanged = () => {
		const creativeData = CreativesDataStore.getData();
		let siteOptions = null;
		CreativesDataStore.getConfig().CreativeData.forEach((option) => {
			if (option.Name === "PlatformSiteID") {
				siteOptions = option.Options;
			}
		});
		if (siteOptions !== null) {
			creativeData.forEach((creative) => {
				if (creative.PlatformSiteID !== null) {
					let platformName = null;
					siteOptions.forEach((site) => {
						if (creative.PlatformSiteID === site.OptionID) {
							platformName = site.OptionLabel;
						}
					});
					if (platformName !== null) {
						creative.PlatformSiteID = platformName;
					}
				}
			});
		}

		let preparredData;

		if (Object.keys(this.state.filterOptions ?? {})?.length > 0) {
			this?.dataTableApi?.current?.dataProvider?.update?.(creativeData);
			preparredData = fullFilterAlgorithm({
				handleFilter: () => {},
				config: CreativesDataStore.getConfig(),
				data: CreativesDataStore.getData(),
				dataTableApi: this.dataTableApi,
				filterOptions: this.state.filterOptions
			});
		} else {
			preparredData = CreativesDataStore.getData();
		}

		this.setState({ creativesData: preparredData, selectedRows: [] });
	};

	openModal = () => {
		this.newCreativeModal.triggerOpenClose();
	};

	editCreative = () => {
		this.setSelectedRow(() => {
			this.editCreativeModal.triggerOpenClose();
		});
	};

	deleteCreative = () => {
		const selectedUniqueIDs = this.state.selectedRows.map((row) => {
			return row.UniqueID;
		});
		const selectedLines = JSON.parse(JSON.stringify(CreativesDataStore.getData()))
			.map((row, index) => {
				row.Row = index;
				return row;
			})
			.filter((row) => {
				return selectedUniqueIDs.includes(row.UniqueID);
			});
		this.setState({ creativesToDelete: selectedLines }, () => {
			this.deleteCreativeModal.triggerOpenClose();
		});
	};

	formatDate = (date) => {
		const d = new Date(date);
		let month = String(d.getMonth() + 1);
		let day = String(d.getDate());
		const year = d.getFullYear();

		if (month.length < 2) month = "0" + month;
		if (day.length < 2) day = "0" + day;

		return [year, month, day].join("/");
	};

	duplicateCreativeData = () => {
		this.setSelectedRow(() => {
			this.duplicateCreative.triggerOpenClose();
		});
	};

	numberSelected = (row, chk, selectAll = false) => {
		let newSelectedRows = JSON.parse(JSON.stringify(this.state.selectedRows));
		if (!selectAll) {
			if (chk) {
				newSelectedRows.push(row);
			} else {
				newSelectedRows = newSelectedRows.filter((selectedRow) => {
					return selectedRow.UniqueID != row.UniqueID;
				});
			}
		} else {
			newSelectedRows = row;
		}
		this.setState({
			selectedRows: newSelectedRows,
			selectedCount: newSelectedRows.length,
			singleSelected: newSelectedRows.length === 1,
			multipleSelected: newSelectedRows.length > 1
		});
	};

	setSelectedRow = (callback) => {
		const selectedLine = this.state.selectedRows[0];
		const dataArr = {};
		Object.keys(selectedLine).forEach((key) => {
			if (key === "EndDate" || key === "StartDate") {
				dataArr[key] = this.formatDate(selectedLine[key]);
			} else if (key === "Budget") {
				dataArr[key] = selectedLine[key].replace(/[^\d.-]/g, "");
			} else if (key === "CreativeName") {
			} else {
				dataArr[key] = selectedLine[key];
			}
		});
		this.setState({ selectedRow: dataArr }, () => {
			callback?.();
		});
	};

	unlockSheet = () => {
		this.setState({
			readOnly: !this.state.readOnly
		});
	};

	handleDuplicate = (dataWithDuplicates, totalCount) => {
		showToast(
			"workbookToasts",
			<ToastNotification
				type={TOAST_TYPE.SUCCESS}
				message="Creatives have been successfully created in bulk. Confirm all fields in the table have been entered."
				timed={10000}
			/>
		);
		this.setState({ creativesData: dataWithDuplicates, readOnly: false }, () => {
			this.dataTableApi.current.dataProvider.currentPage = 0;
			retryAtInterval(
				() => this.dataTableApi?.current?.toolbarApi?.current?.changeActiveMode?.(TOOLBAR_MODE.EDIT),
				() => this.dataTableApi?.current?.toolbarApi?.current?.activeMode === TOOLBAR_MODE.EDIT
			);
		});
	};

	handleRowSelection = (selectedRows) => {
		this.setState({ selectedRows });
	};

	replaceData = (data, toggleEditing = false) => {
		applyFindReplaceToTable({
			data,
			dataTableApi: this.dataTableApi,
			toggleEditing,
			syncData: (updatedData) => {
				this.setState({ creativesData: updatedData });
			}
		});
	};

	handleMultiply = (dataWithMultipliedRows) => {
		showToast(
			"workbookToasts",
			<ToastNotification
				// this comment exists to prevent eslint from making this unreadable.
				type={TOAST_TYPE.SUCCESS}
				message="Creatives multiplied successfully."
				timed={10000}
			/>
		);
		this.setState({ creativesData: dataWithMultipliedRows, readOnly: false }, () => {
			this.dataTableApi.current.dataProvider.currentPage = 0;
			retryAtInterval(
				() => this.dataTableApi?.current?.toolbarApi?.current?.changeActiveMode?.(TOOLBAR_MODE.EDIT),
				() => this.dataTableApi?.current?.toolbarApi?.current?.activeMode === TOOLBAR_MODE.EDIT
			);
		});
	};

	handleFilter = (filteredData, applyFilter, filterOptions) => {
		if (!document.getElementById("Creative_find_replace_modal")?.hasAttribute("open")) {
			if (applyFilter === true) {
				this.setState({
					creativesData: filteredData,
					advancedFilter: true,
					displayFilter: false,
					filterOptions
				});
			} else if (this.state.searchValue !== "") {
				const filteredData = this?.returnSearchedValues?.(this.state.searchValue) || [];
				if (filteredData.length !== 0) {
					this.setState({
						creativesData: filteredData,
						advancedFilter: false,
						displayFilter: false,
						filterOptions: []
					});
				} else {
					this.setState({
						creativesData: CreativesDataStore.getData(),
						advancedFilter: false,
						displayFilter: false,
						filterOptions: []
					});
				}
			} else {
				this.setState({
					creativesData: CreativesDataStore.getData(),
					advancedFilter: false,
					displayFilter: false,
					filterOptions: []
				});
			}
		}
	};

	render() {
		// creativesConfig is for Modal
		const { creativesConfig, creativesData } = this.state;
		const auditLevelID = this.props.auditLevelData.find(({ AuditLevelName }) => AuditLevelName === "Creative")?.AuditLevelID;
		const TMEnabled = WorkbookStore.getIsTrafficEnabled();
		return (
			<section className="tab__container">
				<>
					{/* <Toolbar
						state={this.state}
						addCreative={this.openModal}
						deleteCreative={this.deleteCreative}
						editCreative={this.editCreative}
						duplicateCreative={this.duplicateCreativeData}
						unlockSheet={this.unlockSheet}
					/> */}
					{creativesData && creativesConfig && (
						<>
							<Table
								ref={this.dataTableApi}
								data={creativesData}
								config={creativesConfig}
								hierarchyLevel="Creative"
								metaData={this.props.campaignMetaData}
								// updateSelected={this.numberSelected}
								updateSelected={this.handleRowSelection}
								refetchData={this.refetchData}
								auditLevelID={auditLevelID}
								extraColumns={[COLUMNS.IsDraft]}
								actionBarProps={{
									filtersSideSheet: (
										<FullFiltersSidesheet
											hierarchyLevel="Creative"
											filterOptions={this.state.filterOptions}
											ref={this.dataTableApi}
											data={CreativesDataStore.getData()}
											config={creativesConfig}
											handleFilter={this.handleFilter}
										/>
									),
									editButton: (
										<Button
											// this comment exists to prevent eslint from making this unreadable.
											style={{ order: 2 }}
											display={BUTTON_DISPLAY.SECONDARY}
											size={BUTTON_SIZE.SMALL}
											data-tracking-id-alt="open-edit-creative-details-modal"
										>
											Edit Details
										</Button>
									),
									showEditMode: EDIT_BUTTON_LOCATION.DEFAULT_MODE_ACTIONS,
									defaultModeActions: [
										<Button
											style={{ order: 1 }}
											hierarchyLevel="Creative"
											size={BUTTON_SIZE.SMALL}
											display={BUTTON_DISPLAY.TEXT}
											key="creative-find-replace"
											onClick={() => {
												this.findReplaceModal.triggerOpenClose();
											}}
											data-tracking-id-alt="open-creative-find-replace-modal"
										>
											Find and Replace
										</Button>,
										<Button
											style={{ order: 3 }}
											key="add-creative"
											size={BUTTON_SIZE.SMALL}
											onClick={() => {
												this.newCreativeModal.triggerOpenClose();
											}}
											data-tracking-id-alt="open-add-creative-modal"
										>
											Add Creative
										</Button>
									],
									actions: [
										<Tooltip key="action-clone" title="Clone Creatives" position={TOOLTIP_POSITION.BOTTOM_START}>
											<Button
												size={BUTTON_SIZE.SMALL}
												display={BUTTON_DISPLAY.ICON_BORDERED}
												icon="icon-copy"
												onClick={() => {
													Modal.show("Creative_clone_modal");
												}}
												data-tracking-id-alt="open-clone-creative-modal"
												disabled={draftHLISelected(this.dataTableApi)}
											>
												Clone
											</Button>
										</Tooltip>,
										<Tooltip key="action-multiply" title={`Multiply Creative`} position={TOOLTIP_POSITION.BOTTOM_START}>
											<Button
												size={BUTTON_SIZE.SMALL}
												display={BUTTON_DISPLAY.ICON_BORDERED}
												icon="icon-copy-clipboard"
												onClick={() => {
													Modal.show(`Creative_multiplier`);
												}}
												data-tracking-id-alt="open-creative-multiplier-modal"
												disabled={this.state.selectedRows.length > 1 || draftHLISelected(this.dataTableApi)}
											>
												Creative Multiplier
											</Button>
										</Tooltip>,
										<Tooltip key="action-edit" title="Edit Creative" position={TOOLTIP_POSITION.BOTTOM_START}>
											<Button
												size={BUTTON_SIZE.SMALL}
												display={BUTTON_DISPLAY.ICON_BORDERED}
												icon="icon-pencil"
												disabled={this.state.selectedRows.length > 1}
												onClick={() => {
													this.editCreativeModal.triggerOpenClose();
												}}
												data-tracking-id-alt="open-edit-creative-modal"
											>
												Edit Creative
											</Button>
										</Tooltip>,
										<Tooltip key="action-delete" title="Delete Creative" position={TOOLTIP_POSITION.BOTTOM_START}>
											<Button
												size={BUTTON_SIZE.SMALL}
												display={BUTTON_DISPLAY.ICON_BORDERED}
												icon="icon-trash"
												onClick={() => {
													this.deleteCreative();
												}}
												data-tracking-id-alt="open-delete-creative-modal"
												disabled={this.state.selectedRows.length === 0}
											>
												Delete Creative
											</Button>
										</Tooltip>
									]
								}}
							/>
						</>
					)}

					<NewCreative
						newCreative={(ref) => {
							this.newCreativeModal = ref;
						}}
						config={creativesConfig}
						filters={this.filterChoices}
						metaData={this.props.campaignMetaData}
						updateCounts={this.props.updateCounts}
						auditLevelID={auditLevelID}
					/>
					<EditCreative
						editCreative={(ref) => {
							this.editCreativeModal = ref;
						}}
						data={this.state.selectedRows?.[0]}
						config={creativesConfig}
						filters={this.filterChoices}
						metaData={this.props.campaignMetaData}
						auditLevelID={auditLevelID}
					/>
					<DeleteCreative
						deletePlatformModal={(ref) => {
							this.deleteCreativeModal = ref;
						}}
						type="Creative"
						data={this.state.creativesToDelete}
						multiple={true}
						deleteType="deleteCreative"
						hierarchyLevel="Creative"
						onSubmit={() => {
							// this.props.updateCounts("Creative");
						}}
					>
						<div className="platformListContainer">
							<div className="platformListHeader">
								<span>Creative Name</span>
							</div>

							{this.state.selectedRows.map((line, i) => {
								return (
									<div className="platformInfoRow" key={`deleteplatformline-${i}`}>
										<span className="platformInfo" style={{ width: "100%" }}>
											{line.CreativeName}
										</span>
									</div>
								);
							})}
						</div>
					</DeleteCreative>
					<DuplicatePlatformModal
						config={creativesConfig}
						type="Creative"
						data={this.state.selectedRows}
						handleDuplicate={this.handleDuplicate}
						allRows={creativesData}
					/>

					<MultiplierModal
						data={this.state.selectedRows[0]}
						handleMultiply={this.handleMultiply}
						allRows={creativesData}
						config={creativesConfig}
						type="Creative"
						hierarchyLevel="Creative"
						name="Creative"
					/>

					<FindReplaceModal
						findReplaceModal={(ref) => {
							this.findReplaceModal = ref;
						}}
						type={"Creative"}
						hierarchyLevel="Creative"
						config={creativesConfig}
						data={creativesData}
						replaceData={this.replaceData}
						tableRef={this.dataTableApi}
					/>
				</>
			</section>
		);
	}
}

export default LegacyCreativesView;
